import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import * as Sentry from '@sentry/react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Обновляем состояние, чтобы следующий рендер показал запасной UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // Здесь можно логировать ошибку в сервис мониторинга (Sentry, LogRocket и т.д.)
    console.error('Uncaught error:', error, errorInfo)
    Sentry.captureException(error, { extra: errorInfo })
  }

  render() {
    if (this.state.hasError) {
      // Отображаем любой кастомный UI
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            textAlign: 'center',
            p: 3,
          }}
        >
          <Typography variant="h4" gutterBottom>
            Что-то пошло не так.
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            Мы уже работаем над исправлением. Пожалуйста, попробуйте обновить
            страницу.
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Обновить страницу
          </Button>
        </Box>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
